import React from "react";
import PropTypes from "prop-types";
import { CloudQueue } from "@mui/icons-material";
import graceHillLogo from "../../assets/images/gh_logo_horizontal.png";
import { contentOwners } from "../../constants";

function ContentOwnerPolicyIcon(props) {
  const { contentOwner, clientOwned } = props;
  if (
    contentOwner != contentOwners.graceHill &&
    (contentOwner === contentOwners.custom || clientOwned)
  ) {
    return <CloudQueue color="action" />;
  } else {
    return <img src={graceHillLogo} alt="Grace Hill" width={64} />;
  }
}

export default ContentOwnerPolicyIcon;

ContentOwnerPolicyIcon.propTypes = {
  contentOwner: PropTypes.string.isRequired
};
